<template>
  <div class="home-page">

    <div class="hero-section" ref="heroSection">
      <div class="hero-bg-parallax" ref="heroBg"></div>
      <div class="hero-overlay"></div>
      <div class="hero-inner">
        <div class="hero-text">
          <h1 class="hero-title reveal-title" v-html="$t('home.hero.mainTitle')"></h1>
          <div class="hero-cta reveal-cta">
           <a href="https://book.barbersunity.com/eng/register">
  <button class="btn-primary btn-large">
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"/>
    </svg>
    {{ $t('home.hero.growBusiness') }}
  </button>
</a>

            <a href="https://book.barbersunity.com/eng/register-customer">
              <button class="btn-ghost btn-large">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
                Join as Customer
              </button>
            </a>
          </div>
        </div>
        <div class="hero-image-container reveal-image">
          <img src="@/assets/Document.webp" alt="Barbers Unity Dashboard on a laptop" class="hero-image" ref="heroImage">
        </div>
      </div>
    </div>

    <div class="stats-bar" ref="statsBar">
      <div class="stats-bar-inner">
        <div class="sbar-item">
          <span class="sbar-num">{{ animatedBookings.toLocaleString() }}<span class="sbar-plus">+</span></span>
          <span class="sbar-label">{{ $t('home.stats.bookings') }}</span>
        </div>
        <div class="sbar-div"></div>
        <div class="sbar-item">
          <span class="sbar-num">{{ animatedClients.toLocaleString() }}<span class="sbar-plus">+</span></span>
          <span class="sbar-label">{{ $t('home.stats.clients') }}</span>
        </div>
        <div class="sbar-div"></div>
        <div class="sbar-item">
          <span class="sbar-num">€35</span>
          <span class="sbar-label">flat per month</span>
        </div>
        <div class="sbar-div"></div>
        <div class="sbar-item">
          <span class="sbar-num">{{ animatedHours }}h</span>
          <span class="sbar-label">{{ $t('home.stats.time') }}</span>
        </div>
      </div>
    </div>

    <section class="features-section" ref="featuresSection">
      <div class="features-sticky-layout">

        <div class="feat-labels-col">
          <div class="feat-labels-inner">
            <p class="feat-eyebrow">{{ $t('home.mobile.label') }}</p>
            <div
              v-for="(feat, i) in features"
              :key="i"
              class="feat-label-item"
              :class="{ 'is-active': activeFeat === i }"
              @click="scrollToFeat(i)"
            >
              <span class="feat-label-num">0{{ i + 1 }}</span>
              <span class="feat-label-text">{{ feat.title }}</span>
            </div>
          </div>
        </div>

        <div class="feat-panels-col">
          <div class="feat-panel" :ref="el => featPanelRefs[0] = el">
            <div class="feat-screen-wrap screen-web">
              <div class="screen-chrome">
                <span class="chrome-dot"></span><span class="chrome-dot"></span><span class="chrome-dot"></span>
              </div>
              <img src="@/assets/desktopsc.webp" :alt="features[0]?.title" class="feat-screen-img--web" />
            </div>
            <div class="feat-panel-text">
              <h3 class="feat-panel-title">{{ features[0]?.title }}</h3>
              <p class="feat-panel-desc">{{ features[0]?.desc }}</p>
            </div>
          </div>

          <div class="feat-panel" :ref="el => featPanelRefs[1] = el">
            <div class="feat-screen-wrap screen-mobile">
              <div class="screen-notch"></div>
              <img src="@/assets/Document.webp" :alt="features[1]?.title" class="feat-screen-img--mobile" />
            </div>
            <div class="feat-panel-text">
              <h3 class="feat-panel-title">{{ features[1]?.title }}</h3>
              <p class="feat-panel-desc">{{ features[1]?.desc }}</p>
            </div>
          </div>

          <div class="feat-panel" :ref="el => featPanelRefs[2] = el">
            <div class="feat-screen-wrap screen-web">
              <div class="screen-chrome">
                <span class="chrome-dot"></span><span class="chrome-dot"></span><span class="chrome-dot"></span>
              </div>
              <img src="@/assets/desktopsc1.webp" :alt="features[2]?.title" class="feat-screen-img--web" />
            </div>
            <div class="feat-panel-text">
              <h3 class="feat-panel-title">{{ features[2]?.title }}</h3>
              <p class="feat-panel-desc">{{ features[2]?.desc }}</p>
            </div>
          </div>

          <div class="feat-panel" :ref="el => featPanelRefs[3] = el">
            <div class="feat-screen-wrap screen-mobile">
              <div class="screen-notch"></div>
              <img src="@/assets/Document1.webp" :alt="features[3]?.title" class="feat-screen-img--mobile" />
            </div>
            <div class="feat-panel-text">
              <h3 class="feat-panel-title">{{ features[3]?.title }}</h3>
              <p class="feat-panel-desc">{{ features[3]?.desc }}</p>
            </div>
          </div>
        </div>

      </div>
    </section>

    <!-- ════════════════════════════════════════
         CALENDAR PREVIEW — new section
    ════════════════════════════════════════ -->
    <section class="calendar-preview-section">
      <div class="calendar-preview-inner" ref="calendarPreview">
        <div class="calendar-preview-header">
          <span class="eyebrow">{{ $t('home.mobile.label') }}</span>
          <h2 class="calendar-preview-title">{{ $t('home.calendar_preview.title') }}</h2>
        </div>
        <div class="devices-container">
          <div class="device device--laptop">
            <img src="@/assets/laptopcalendar.png" alt="Calendar on laptop" class="device-screen">
          </div>
          <div class="device device--tablet">
            <img src="@/assets/tabletcalendar.png" alt="Calendar on tablet" class="device-screen">
          </div>
          <div class="device device--phone">
            <img src="@/assets/phonecalendar.png" alt="Calendar on phone" class="device-screen">
          </div>
        </div>
      </div>
    </section>


    <section class="how-section">
      <div class="how-inner">
        <div class="how-header">
          <span class="eyebrow">{{ $t('home.how.label') }}</span>
          <h2 class="how-title">{{ $t('home.how.title') }}</h2>
        </div>
        <div class="how-timeline" ref="howTimeline">
          <div class="how-line"></div>
          <div
            class="how-step"
            v-for="(step, i) in steps"
            :key="i"
            :ref="el => stepRefs[i] = el"
          >
            <div class="how-step-dot">
              <svg v-if="i === 0" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <svg v-if="i === 1" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.72"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.72-1.72"/></svg>
              <svg v-if="i === 2" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><line x1="20" y1="4" x2="8.12" y2="15.88"/><line x1="14.47" y1="14.48" x2="20" y2="20"/><line x1="8.12" y1="8.12" x2="12" y2="12"/></svg>
            </div>
            <h4 class="how-step-title">{{ step.title }}</h4>
          </div>
        </div>
      </div>
    </section>

    <section class="quote-section">
      <div class="quote-inner" ref="quoteInner">
        <div class="quote-mark">"</div>
        <blockquote class="quote-text">{{ $t('home.testimonial.quote') }}</blockquote>
        <div class="quote-author">
          <!-- Replace this div with an <img> tag when you have a real photo -->
          <div class="quote-avatar">PB</div>
          <div>
            <div class="quote-name">{{ $t('home.testimonial.name') }}</div>
            <div class="quote-role">{{ $t('home.testimonial.role') }}</div>
          </div>
          <div class="quote-stars">★★★★★</div>
        </div>
      </div>
    </section>

    <section class="pricing-section">
      <div class="pricing-wrap">
        <div class="pricing-grid" ref="pricingCard">
          <div class="pricing-visual">
            <span class="eyebrow">{{ $t('home.pricing.label') }}</span>
            <div class="pricing-amount">€35</div>
            <div class="pricing-period">{{ $t('home.pricing.period') }}</div>
          </div>
          <div class="pricing-details">
            <h2 class="pricing-headline">{{ $t('home.pricing.title') }}</h2>
            <p class="pricing-sub">{{ $t('home.pricing.desc') }}</p>
            <ul class="pricing-features-minimal">
              <li v-for="item in $t('home.pricing.featuresList')" :key="item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="faq-section">
      <div class="faq-wrap">
        <h2 class="faq-title">{{ $t('home.faq.title') }}</h2>
        <div class="faq-list">
          <div
            class="faq-item"
            v-for="(faq, i) in faqsData"
            :key="i"
            :class="{ 'is-open': faq.isOpen }"
            @click="toggleFaq(i)"
          >
            <div class="faq-q">
              {{ faq.q }}
              <span class="faq-icon">+</span>
            </div>
            <div class="faq-a-wrap">
              <div class="faq-a-inner">
                <p class="faq-a">{{ faq.a }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-strip">
      <div class="cta-inner" ref="ctaInner">
        <div class="cta-glow"></div>
        <h2 class="cta-title">{{ $t('home.cta.title') }}</h2>
        <div class="cta-buttons">
          <router-link to="/forbussines">
            <button class="btn-primary btn-large">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14m-7-7 7 7-7 7"/>
              </svg>
              {{ $t('home.cta.button') }}
            </button>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'HomePage',
  data() {
    return {
      animatedBookings: 0,
      animatedClients: 0,
      animatedHours: 0,
      statsAnimated: false,
      activeFeat: 0,
      featPanelRefs: [],
      stepRefs: [],
      observers: [],
      gsapCtx: null,
      mm: null,
      scrollRaf: null,
      openFaqs: [],
      _destroyed: false,
      _mountTimer: null,
      _refreshTimers: [],
      _countIntervals: [],
    }
  },
  computed: {
    features() { return this.$t('home.featuresList') },
    steps()    { return this.$t('home.stepsList') },
    faqsData() {
      const list = this.$t('home.faqList')
      if (!Array.isArray(list)) return []
      return list.map((faq, i) => ({ ...faq, isOpen: this.openFaqs.includes(i) }))
    }
  },
  mounted() {
    this._destroyed = false
    this._mountTimer = setTimeout(() => {
      if (this._destroyed) return
      this.$nextTick(() => {
        if (this._destroyed) return
        this.initGSAP()
        this.initStatsObserver()
        this.initFeatObserver()
        window.addEventListener('scroll', this.handleHeroScroll, { passive: true })

        const t = setTimeout(() => {
          if (this._destroyed) return
          ScrollTrigger.refresh()
        }, 300)
        this._refreshTimers.push(t)
      })
    }, 800)
  },
  beforeUnmount() {
    this._destroyed = true

    if (this._mountTimer) { clearTimeout(this._mountTimer); this._mountTimer = null }
    this._refreshTimers.forEach(t => clearTimeout(t))
    this._refreshTimers = []

    this._countIntervals.forEach(i => clearInterval(i))
    this._countIntervals = []

    this.observers.forEach(o => { try { o.disconnect() } catch (_) {} })
    this.observers = []

    if (this.mm) { try { this.mm.revert() } catch (_) {} this.mm = null }
    if (this.gsapCtx) { try { this.gsapCtx.revert() } catch (_) {} this.gsapCtx = null }

    window.removeEventListener('scroll', this.handleHeroScroll)
    if (this.scrollRaf) { cancelAnimationFrame(this.scrollRaf); this.scrollRaf = null }

    try {
      ScrollTrigger.getAll().forEach(t => { try { t.kill() } catch (_) {} })
      ScrollTrigger.clearScrollMemory()
    } catch (_) {}
  },
  methods: {
    handleHeroScroll() {
      if (this._destroyed) return
      if (!this.$refs.heroImage || !this.$refs.heroSection) return
      if (this.scrollRaf) return
      this.scrollRaf = window.requestAnimationFrame(() => {
        const rect = this.$refs.heroSection.getBoundingClientRect()
        const scrollDistance = Math.max(0, -rect.top)
        const progress = Math.min(scrollDistance / 700, 1)
        this.$refs.heroImage.style.transform = `scale(${1 + progress * 0.15})`
        this.scrollRaf = null
      })
    },

    initGSAP() {
      if (this._destroyed) return
      const bg = this.$refs.heroBg
      if (!bg) return
      this.gsapCtx = gsap.context(() => {
        gsap.fromTo(bg,
          { scale: 1.1 },
          { scale: 1.0, ease: 'none',
            scrollTrigger: { trigger: this.$refs.heroSection, start: 'top top', end: 'bottom top', scrub: true } }
        )
        gsap.to('.hero-text', {
          y: -50, ease: 'none',
          scrollTrigger: { trigger: this.$refs.heroSection, start: 'top top', end: 'bottom top', scrub: true }
        })

        if (this.$refs.statsBar) {
          gsap.fromTo('.sbar-item',
            { opacity: 0, y: 14 },
            { opacity: 1, y: 0, duration: 0.55, stagger: 0.09, ease: 'power2.out',
              scrollTrigger: { trigger: this.$refs.statsBar, start: 'top 88%' } }
          )
        }

        this.featPanelRefs.forEach((el) => {
          if (!el) return
          gsap.fromTo(el.querySelector('.feat-screen-wrap'),
            { opacity: 0, y: 32, scale: 0.97 },
            { opacity: 1, y: 0, scale: 1, duration: 0.85, ease: 'power3.out',
              scrollTrigger: { trigger: el, start: 'top 75%' } }
          )
          gsap.fromTo(el.querySelector('.feat-panel-text'),
            { opacity: 0, x: -20 },
            { opacity: 1, x: 0, duration: 0.7, ease: 'power2.out',
              scrollTrigger: { trigger: el, start: 'top 75%' } }
          )
        })

        if (this.$refs.howTimeline) {
          const howTl = gsap.timeline({ scrollTrigger: { trigger: this.$refs.howTimeline, start: 'top 80%' } });
          howTl.from('.how-line', { scaleX: 0, duration: 1.2, ease: 'power2.inOut' });
          this.stepRefs.filter(Boolean).forEach((el, i) => {
            howTl.from(el.querySelector('.how-step-dot'), { scale: 0, opacity: 0, duration: 0.5, ease: 'back.out(1.7)' }, '-=0.8')
                 .from(el.querySelector('.how-step-title'), { opacity: 0, y: 10, duration: 0.5, ease: 'power2.out' }, '<0.2');
          })
        }

        if (this.$refs.quoteInner) {
          const quoteTl = gsap.timeline({ scrollTrigger: { trigger: '.quote-section', start: 'top 75%' } });
          quoteTl.from('.quote-mark', { opacity: 0, scale: 0.5, duration: 0.6, ease: 'power2.out' })
                 .from('.quote-text', { opacity: 0, y: 20, duration: 0.7, ease: 'power2.out' }, '-=0.3')
                 .from('.quote-author', { opacity: 0, y: 15, duration: 0.6, ease: 'power2.out' }, '-=0.3');
        }

        if (this.$refs.pricingCard) {
          gsap.fromTo(this.$refs.pricingCard,
            { opacity: 0, y: 30, scale: 0.98 },
            { opacity: 1, y: 0, scale: 1, duration: 0.85, ease: 'power3.out',
              scrollTrigger: { trigger: this.$refs.pricingCard, start: 'top 80%' } }
          )
        }

        gsap.utils.toArray('.faq-item').forEach((item) => {
          gsap.from(item, {
            opacity: 0,
            y: 30,
            duration: 0.6,
            ease: 'power2.out',
            scrollTrigger: { trigger: item, start: 'top 90%' }
          });
        });

        if (this.$refs.ctaInner) {
          gsap.fromTo(this.$refs.ctaInner,
            { scale: 0.97, opacity: 0 },
            { scale: 1, opacity: 1, duration: 0.8, ease: 'power2.out',
              scrollTrigger: { trigger: '.cta-strip', start: 'top 82%' } }
          )
        }

        if (this.$refs.calendarPreview) {
          const previewSection = this.$refs.calendarPreview;
          const devicesContainer = previewSection.querySelector('.devices-container');
          const header = previewSection.querySelector('.calendar-preview-header');
          const tablet = previewSection.querySelector('.device--tablet');
          const phone = previewSection.querySelector('.device--phone');
          const laptop = previewSection.querySelector('.device--laptop');

          gsap.fromTo(header,
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out',
              scrollTrigger: { trigger: previewSection, start: 'top 80%' } }
          );

          const mm = gsap.matchMedia()
          this.mm = mm

          // Desktop AND small phones (<=640px) get the overlapping layout.
          // The mid-range (641px–768px) gets the simpler stacked layout below.
          mm.add("(min-width: 769px), (max-width: 640px)", () => {
            gsap.set(tablet, { xPercent: -250, yPercent: 15, opacity: 0 });
            gsap.set(phone, { xPercent: 350, yPercent: 10, opacity: 0 });

            const devicesTl = gsap.timeline({
              scrollTrigger: { trigger: devicesContainer, start: 'top 75%' }
            });

            devicesTl.fromTo(laptop, { opacity: 0 }, { opacity: 1, duration: 1 })
                     .to(tablet, { xPercent: -60, opacity: 1, duration: 1.6, ease: 'power3.out' }, 0)
                     .to(phone, { xPercent: 150, opacity: 1, duration: 1.6, ease: 'power3.out' }, 0);
          });

          mm.add("(max-width: 768px) and (min-width: 641px)", () => {
            gsap.set([laptop, tablet, phone], { clearProps: "all" });

            const mobileTl = gsap.timeline({
              scrollTrigger: { trigger: devicesContainer, start: 'top 85%' }
            });

            mobileTl.fromTo('.device',
              { opacity: 0, y: 30 },
              { opacity: 1, y: 0, duration: 0.8, stagger: 0.2, ease: 'power3.out' }
            );
          });
        }

        const t2 = setTimeout(() => {
          if (this._destroyed) return
          ScrollTrigger.refresh()
        }, 500)
        this._refreshTimers.push(t2)
      })
    },

    initStatsObserver() {
      if (this._destroyed) return
      const el = this.$refs.statsBar
      if (!el) return
      const obs = new IntersectionObserver((entries) => {
        if (this._destroyed) return
        if (entries[0].isIntersecting && !this.statsAnimated) {
          this.statsAnimated = true
          this.animateCount('animatedBookings', 1247, 1400)
          this.animateCount('animatedClients',  3180, 1600)
          this.animateCount('animatedHours',    4,    800)
        }
      }, { threshold: 0.4 })
      obs.observe(el)
      this.observers.push(obs)
    },

    initFeatObserver() {
      if (this._destroyed) return
      this.$nextTick(() => {
        if (this._destroyed) return
        this.featPanelRefs.filter(Boolean).forEach((el, i) => {
          const obs = new IntersectionObserver((entries) => {
            if (this._destroyed) return
            if (entries[0].isIntersecting) this.activeFeat = i
          }, { threshold: 0.5 })
          obs.observe(el)
          this.observers.push(obs)
        })
      })
    },

    scrollToFeat(i) {
      const el = this.featPanelRefs[i]
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },

    toggleFaq(index) {
      const pos = this.openFaqs.indexOf(index)
      if (pos !== -1) this.openFaqs.splice(pos, 1)
      else this.openFaqs.push(index)
    },

    animateCount(key, target, duration) {
      const step = target / (duration / 16)
      let cur = 0
      const t = setInterval(() => {
        if (this._destroyed) { clearInterval(t); return }
        cur += step
        if (cur >= target) { this[key] = target; clearInterval(t) }
        else { this[key] = Math.floor(cur) }
      }, 16)
      this._countIntervals.push(t)
    },
  }
}
</script>

<style scoped>
/* ═══════════════════════════════════
   TOKENS
═══════════════════════════════════ */
.home-page {
  --accent:        #4a7fa5;
  --accent-light:  #6499bb;
  --accent-dim:    rgba(74,127,165,0.09);
  --accent-border: rgba(74,127,165,0.22);
  --accent-glow:   rgba(74,127,165,0.28);
  --surface:       rgba(10,16,30,0.6);
  --border:        rgba(255,255,255,0.065);
  --border-hover:  rgba(255,255,255,0.13);
  --text-primary:  #e8edf4;
  --text-secondary:#8b95a7; /* Improved readability */
  --text-muted:    #67707e; /* Improved readability */
  color: var(--text-primary);
}

/* ═══════════════════════════════════
   SHARED UTILITIES
═══════════════════════════════════ */
.eyebrow {
  display: block;
  font-size: 0.62rem; font-weight: 800;
  letter-spacing: 0.22em; text-transform: uppercase;
  color: var(--accent); margin-bottom: 0.65rem;
}
.btn-primary {
  display: inline-flex; align-items: center; gap: 8px;
  background: var(--accent); color: #fff; font-weight: 700; font-size: 0.88rem;
  padding: 0.8rem 1.8rem; border-radius: 10px; border: none;
  cursor: pointer; position: relative; overflow: hidden;
  transition: background 0.22s, transform 0.2s, box-shadow 0.2s;
  text-decoration: none;
}
.btn-primary::after { content:''; position:absolute; inset:0; background:linear-gradient(135deg,rgba(255,255,255,0.12),transparent); opacity:0; transition:opacity 0.22s; }
.btn-primary:hover  { background: var(--accent-light); transform: translateY(-3px); box-shadow: 0 10px 28px var(--accent-glow); }
.btn-primary:hover::after { opacity:1; }
.btn-primary:active { transform: translateY(-1px); }
.btn-ghost {
  display: inline-flex; align-items: center; gap: 7px;
  background: transparent; color: var(--text-secondary); font-weight: 600; font-size: 0.88rem;
  padding: 0.8rem 1.8rem; border-radius: 10px; border: 1px solid var(--border-hover);
  cursor: pointer; transition: all 0.22s; text-decoration: none;
}
.btn-ghost:hover { background: rgba(255,255,255,0.04); border-color: rgba(255,255,255,0.22); color: #d4e0ec; transform: translateY(-2px); }
.btn-large { padding: 1rem 2.5rem; font-size: 0.95rem; border-radius: 12px; }

/* ═══════════════════════════════════
   HERO
═══════════════════════════════════ */
.hero-section {
  min-height: 90vh; position: relative; overflow: hidden; /* Fixed excessive height */
  display: flex; align-items: center; justify-content: center;
  padding: 5rem 1.5rem 4rem;
  border-radius: 0 0 32px 32px;
}
.hero-bg-parallax {
  position: absolute; inset: -10%;
  background-image: url('@/assets/background.webp');
  background-size: cover; background-position: center top;
  will-change: transform; transform-origin: center top;
}
.hero-overlay { position: absolute; inset: 0; }
.hero-inner { position: relative; z-index: 3; width: 100%; max-width: 1100px; margin: 0 auto; }
.hero-text { display: flex; flex-direction: column; align-items: center; text-align: center; will-change: transform; }
.reveal-title { animation: fadeUp 0.8s cubic-bezier(.22,1,.36,1) 0.05s both; }
.reveal-cta   { animation: fadeUp 0.8s cubic-bezier(.22,1,.36,1) 0.38s both; }
.reveal-image { animation: fadeUp 0.8s cubic-bezier(.22,1,.36,1) 0.45s both; }
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(26px); filter: blur(5px); }
  to   { opacity: 1; transform: translateY(0);    filter: blur(0); }
}
.hero-title {
  font-size: clamp(2.5rem, 5.5vw, 4.4rem); font-weight: 900; line-height: 1.07;
  letter-spacing: -0.035em; margin-top: 1.6rem; margin-bottom: 1.5rem; color: var(--accent); /* Consolidated margin */
}
.hero-title-accent {
  background: linear-gradient(130deg, #c8dce8 0%, #7fb3cc 45%, var(--accent-light) 100%);
  -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
}
.hero-image-container {
  margin-top: 3.5rem; margin-bottom: 2.5rem; /* Tightened margin */
  display: flex; justify-content: center; perspective: 1500px;
}
.hero-image {
  width: 100%; max-width: 480px; height: auto; border-radius: 12px; /* Increased max-width */
  will-change: transform; transform-origin: center center;
}
.hero-cta { display: flex; flex-wrap: wrap; gap: 1rem; justify-content: center; margin-bottom: 2.5rem; margin-top: 2.5rem; }

/* ═══════════════════════════════════
   STATS BAR
═══════════════════════════════════ */
.stats-bar {
  background: rgba(6,10,22,0.75);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}
.stats-bar-inner {
  max-width: 1100px; margin: 0 auto; padding: 0 1.5rem;
  display: flex; align-items: stretch;
}
.sbar-item {
  flex: 1; display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  padding: 1.6rem 1rem; gap: 0.25rem;
}
.sbar-num {
  font-size: 1.7rem; font-weight: 900; letter-spacing: -0.04em;
  color: var(--text-primary); line-height: 1;
}
.sbar-plus { font-size: 1.1rem; opacity: 0.55; margin-left: 1px; }
.sbar-label {
  font-size: 0.7rem; font-weight: 600; letter-spacing: 0.05em; /* Slightly larger label */
  color: var(--text-muted); text-align: center; line-height: 1.4;
}
.sbar-div { width: 1px; background: var(--border); align-self: stretch; margin: 0.75rem 0; }

/* ═══════════════════════════════════
   FEATURES
═══════════════════════════════════ */
.features-section { border-top: 1px solid var(--border); padding: 0; }
.features-sticky-layout {
  max-width: 1100px; margin: 0 auto; padding: 0 1.5rem;
  display: grid; grid-template-columns: 240px 1fr; gap: 0; align-items: start;
}
.feat-labels-col {
  position: sticky; top: 6rem; padding: 5rem 2.5rem 5rem 0; border-right: 1px solid var(--border);
}
.feat-labels-inner { display: flex; flex-direction: column; gap: 0; }
.feat-eyebrow {
  font-size: 0.6rem; font-weight: 800; letter-spacing: 0.22em; text-transform: uppercase;
  color: var(--accent); margin-bottom: 2rem;
}
.feat-label-item {
  display: flex; align-items: baseline; gap: 0.75rem; padding: 0.85rem 0;
  border-bottom: 1px solid transparent; cursor: pointer; transition: all 0.25s; opacity: 0.5; /* Slightly brighter inactive state */
}
.feat-label-item.is-active { opacity: 1; border-bottom-color: var(--accent-border); }
.feat-label-num { font-size: 0.6rem; font-weight: 800; letter-spacing: 0.12em; color: var(--accent); flex-shrink: 0; width: 22px; }
.feat-label-text { font-size: 0.82rem; font-weight: 700; color: var(--text-primary); line-height: 1.3; }
.feat-label-item.is-active .feat-label-text { color: #fff; }

.feat-panels-col { padding-left: 4rem; }
.feat-panel { padding: 4rem 0; border-bottom: 1px solid var(--border); display: flex; flex-direction: column; gap: 2rem; } /* Reduced vertical padding */
.feat-panel:last-child { border-bottom: none; }

/* Mobile CSS accurately restored */
.screen-mobile {
  max-width: 320px;
  margin: 0 auto; /* Ensured centering */
}
.feat-screen-img--web { width: 80%; display: block; height: auto; margin: 0 auto; /* Ensured centering */ }
.feat-screen-img--mobile { width: 70%; display: block; height: auto; margin: 0 auto; /* Ensured centering */ }

.feat-panel-title {
  font-size: clamp(1.35rem, 2.2vw, 1.8rem); font-weight: 900;
  letter-spacing: -0.025em; color: var(--text-primary); margin-bottom: 0.75rem; line-height: 1.2;
  text-align: center; /* Center align title to match image alignment */
}
.feat-panel-desc { font-size: 0.95rem; color: var(--text-secondary); line-height: 1.75; max-width: 480px; margin: 0 auto; text-align: center; /* Center align desc */ }

/* ═══════════════════════════════════
   CALENDAR PREVIEW
═══════════════════════════════════ */
.calendar-preview-section {
  padding: 8rem 1.5rem;
  border-top: 1px solid var(--border);
  background: radial-gradient(ellipse 80% 60% at 50% 100%, rgba(74,127,165,0.06), transparent);
}
.calendar-preview-inner { max-width: 1100px; margin: 0 auto; }
.calendar-preview-header { text-align: center; margin-bottom: 4rem; }
.calendar-preview-title {
  font-size: clamp(1.8rem, 3.5vw, 2.6rem); font-weight: 900;
  letter-spacing: -0.03em; color: var(--text-primary); line-height: 1.2;
}
.devices-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 500px; 
  perspective: 2000px;
}
.device {
  position: absolute; 
}
.device-screen {
  width: 100%; height: auto; display: block;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0,0,0,0.35);
  filter: drop-shadow(0 10px 8px rgba(0,0,0,0.1));
}

.device--laptop {
  width: 65%; max-width: 750px; z-index: 1;
}
.device--tablet {
  width: 35%; max-width: 400px; z-index: 2;

}
.device--phone {
  width: 15%; max-width: 180px; z-index: 3;

}

/* ═══════════════════════════════════
   HOW IT WORKS
═══════════════════════════════════ */
.how-section { border-top: 1px solid var(--border); padding: 7rem 0; }
.how-inner { max-width: 1100px; margin: 0 auto; padding: 0 1.5rem; }
.how-header { margin-bottom: 4rem; }
.how-title {
  font-size: clamp(1.65rem, 3vw, 2.4rem); font-weight: 900;
  letter-spacing: -0.025em; color: var(--text-primary); line-height: 1.2;
}
.how-timeline { position: relative; display: grid; grid-template-columns: repeat(3, 1fr); gap: 3rem; }
.how-line {
  position: absolute; top: 18px; left: calc(50% / 3); right: calc(50% / 3); height: 1px;
  background: linear-gradient(90deg, var(--accent-border), var(--accent-light), var(--accent-border));
  transform-origin: left center;
}
.how-step { position: relative; padding-top: 3rem; }
.how-step-dot {
  position: absolute; top: 0; left: 0; width: 36px; height: 36px; border-radius: 50%;
  background: var(--accent-dim); border: 1px solid var(--accent-border);
  display: flex; align-items: center; justify-content: center;
}
.how-step-n { font-size: 0.72rem; font-weight: 900; color: var(--accent-light); letter-spacing: 0; }
.how-step-title { font-size: 1rem; font-weight: 800; color: var(--text-primary); margin-bottom: 0.6rem; }
.how-step-desc { font-size: 0.82rem; color: var(--text-secondary); line-height: 1.7; }

/* ═══════════════════════════════════
   TESTIMONIAL
═══════════════════════════════════ */
.quote-section {
  border-top: 1px solid var(--border); padding: 8rem 1.5rem;
  background: radial-gradient(ellipse 60% 50% at 50% 0%, rgba(74,127,165,0.05) 0%, transparent 100%);
}
.quote-inner { max-width: 820px; margin: 0 auto; text-align: center; }
.quote-mark {
  font-size: 6rem; font-weight: 900; line-height: 0.65; color: var(--accent); opacity: 0.18;
  font-family: Georgia, 'Times New Roman', serif; margin-bottom: 1.5rem; user-select: none;
}
.quote-text {
  font-size: clamp(1.1rem, 2vw, 1.4rem); line-height: 1.8; color: #b8c8d8;
  font-style: italic; font-weight: 400; margin-bottom: 2.5rem;
}
.quote-author {
  display: inline-flex; align-items: center; gap: 1rem; text-align: left;
  background: var(--surface); border: 1px solid var(--border); border-radius: 100px;
  padding: 0.65rem 1.25rem 0.65rem 0.65rem; backdrop-filter: blur(12px);
}
.quote-avatar {
  width: 38px; height: 38px; border-radius: 50%;
  background: linear-gradient(135deg, var(--accent), #2d6080);
  display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 0.75rem; color: white; flex-shrink: 0;
}
.quote-name { font-size: 0.85rem; font-weight: 700; color: #dce8f0; }
.quote-role { font-size: 0.7rem; color: var(--text-muted); margin-top: 1px; }
.quote-stars { color: #b8923e; font-size: 0.85rem; letter-spacing: 2px; margin-left: 0.5rem; }

.pricing-section { padding: 8rem 0; border-top: 1px solid var(--border); }
.pricing-wrap { max-width: 1000px; margin: 0 auto; padding: 0 1.5rem; }
.pricing-grid {
  display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: stretch; /* Fixed vertical alignment */
}
.pricing-visual {
  display: flex; flex-direction: column; justify-content: center;
  border-right: 1px solid var(--border); padding-right: 4rem;
}
.pricing-amount {
  font-size: clamp(4rem, 8vw, 6rem); font-weight: 900; letter-spacing: -0.05em;
  color: var(--accent-light); line-height: 1; margin-bottom: 0.5rem;
}
.pricing-period {
  font-size: 1rem; font-weight: 600; color: var(--text-muted); letter-spacing: 0.05em; text-transform: uppercase;
}
.pricing-details { display: flex; flex-direction: column; justify-content: center; }
.pricing-headline {
  font-size: clamp(1.8rem, 3vw, 2.2rem); font-weight: 900;
  letter-spacing: -0.025em; color: var(--text-primary); margin-bottom: 1rem; line-height: 1.1;
}
.pricing-sub { font-size: 0.95rem; color: var(--text-secondary); line-height: 1.6; margin-bottom: 2rem; max-width: 400px; }
.pricing-features-minimal { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 1rem; }
.pricing-features-minimal li {
  display: flex; align-items: center; gap: 0.85rem; font-size: 0.95rem; font-weight: 500; color: #d0dce8;
}
.pricing-features-minimal svg { color: var(--accent-light); flex-shrink: 0; }

/* ═══════════════════════════════════
   FAQ
═══════════════════════════════════ */
.faq-section { padding: 5rem 0; border-top: 1px solid var(--border); }
.faq-wrap { max-width: 720px; margin: 0 auto; padding: 0 1.5rem; }
.faq-title {
  font-size: clamp(1.5rem, 2.5vw, 2rem); font-weight: 900;
  letter-spacing: -0.025em; color: var(--text-primary); margin-bottom: 2rem; text-align: center;
}
.faq-list { display: flex; flex-direction: column; gap: 0.75rem; }
.faq-item {
  background: var(--surface); border: 1px solid var(--border); border-radius: 14px; overflow: hidden;
  cursor: pointer; transition: border-color 0.25s, background 0.25s;
}
.faq-item:hover { border-color: var(--border-hover); background: rgba(255,255,255,0.015); }
.faq-item.is-open { border-color: var(--accent-border); }
.faq-q { padding: 1.4rem 1.75rem; display: flex; justify-content: space-between; align-items: center; font-weight: 700; font-size: 1rem; color: #e2e8f0; user-select: none; gap: 1rem; }
.faq-icon { font-size: 1.35rem; font-weight: 300; transition: transform 0.3s ease; color: var(--accent-light); flex-shrink: 0; }
.faq-item.is-open .faq-icon { transform: rotate(45deg); }
.faq-a-wrap { display: grid; grid-template-rows: 0fr; transition: grid-template-rows 0.35s cubic-bezier(0.4,0,0.2,1); }
.faq-item.is-open .faq-a-wrap { grid-template-rows: 1fr; }
.faq-a-inner { overflow: hidden; min-height: 0; }
.faq-a { padding: 0 1.75rem 1.4rem; font-size: 0.92rem; color: var(--text-secondary); line-height: 1.7; }

/* ═══════════════════════════════════
   CTA STRIP
═══════════════════════════════════ */
.cta-strip  { padding: 7rem 1.5rem; border-top: 1px solid var(--border); }
.cta-inner  {
  max-width: 820px; margin: 0 auto; text-align: center; position: relative; overflow: hidden;
  background: var(--surface); border: 1px solid var(--accent-border);
  border-radius: 28px; padding: 5rem 3rem; backdrop-filter: blur(20px);
}
.cta-glow { position: absolute; top: -120px; left: 50%; transform: translateX(-50%); width: 400px; height: 300px; border-radius: 50%; background: radial-gradient(circle, var(--accent-dim) 0%, transparent 70%); pointer-events: none; }
.cta-title { font-size: clamp(2rem, 4.5vw, 3.1rem); font-weight: 900; letter-spacing: -0.03em; color: var(--text-primary); margin-bottom: 2.5rem; }
.cta-buttons { display: flex; justify-content: center; }


/* ═══════════════════════════════════
   RESPONSIVE
═══════════════════════════════════ */
@media (max-width: 960px) {
  /* 1. Hide the tabs completely */
  .feat-labels-col { 
    display: none !important; 
  }

  /* 2. Update layout and center contents */
  .features-sticky-layout { 
    grid-template-columns: 1fr; 
  }
  
  .feat-panels-col { 
    padding-left: 0; 
  }

  .feat-panel { 
    padding: 3rem 0; 
    align-items: center;   /* Centers images/text horizontally */
    text-align: center;    /* Ensures text is centered */
  }

  /* Ensure text doesn't overflow or align weirdly */
  .feat-panel-desc {
    margin: 0 auto; 
  }

  /* Both screenshot styles use display:block, so text-align:center on the
     parent doesn't center them — they need their own auto margins. */
  .feat-screen-img--web,
  .feat-screen-img--mobile {
    margin: 0 auto;
  }

  /* Existing responsive styles for other sections */
  .how-timeline { grid-template-columns: 1fr; gap: 2.5rem; }
  .how-line { display: none; }
  .how-step { padding-top: 3rem; }
  .pricing-grid { grid-template-columns: 1fr; gap: 2.5rem; text-align: center; }
  .pricing-visual { border-right: none; padding-right: 0; border-bottom: 1px solid var(--border); padding-bottom: 2.5rem; }
  .pricing-features-minimal { align-items: center; }
}
@media (max-width: 768px) {
  .devices-container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: auto;
    gap: 2.5rem;
    perspective: none;
  }
  .device { position: relative; } /* CRITICAL: Allows natural stacking on mobile */
  .device--laptop { width: 100%; order: 1; margin: 0 auto; }
  .device--tablet { width: 80%; max-width: 320px; order: 2; margin: 0 auto; }
  .device--phone { width: 50%; max-width: 220px; order: 3; margin: 0 auto; }
  .calendar-preview-section { padding: 5rem 1.5rem; }
}
@media (max-width: 640px) {
  .stats-bar-inner { flex-wrap: wrap; }
  .sbar-item { min-width: 50%; }
  .sbar-div { display: none; }
  .cta-inner { padding: 3rem 1.5rem; }
  .hero-title { font-size: clamp(2.5rem, 5.5vw, 4.4rem); }
  /* Ensure Mobile scales down cleanly on small viewports */
  .screen-mobile { max-width: 260px; }

  /* On true phone widths, go back to the overlapping desktop-style
     layout (same order/placement), just scaled down for the container. */
  .devices-container {
    flex-direction: row;
    position: relative;
    align-items: center;
    justify-content: center;
    min-height: 260px;
    perspective: 900px;
    gap: 0;
  }
  .device { position: absolute; }
  .device--laptop { width: 65%; max-width: 750px; z-index: 1; order: initial; margin: 0; }
  .device--tablet { width: 35%; max-width: 400px; z-index: 2; order: initial; margin: 0; }
  .device--phone  { width: 15%; max-width: 180px; z-index: 3; order: initial; margin: 0; }
}
</style>